export const CHECKOUT_FLOW_STEPS = [
  { label: 'Review Basket' },
  { label: 'Invoice & Payment' },
];
